import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { WithPaymentPlan } from '../types/conversations/payment-plan.model';

@Pipe({
  name: 'lastPaymentPlanTransaction',
})
export class LastPaymentPlanTransactionPipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) {}

  transform(value: WithPaymentPlan, format: string = 'date'): string {
    const plan = value?.paymentPlan;
    const hasTransactions = plan?.transactions?.length && plan.isActive;
    if (!hasTransactions || !plan.transactions.length) {
      return format === 'date' ? 'None' : 'N/A';
    }
    const lastTransaction = plan.transactions[plan.transactions.length - 1];
    return this.datePipe.transform(lastTransaction.date, 'mediumDate', 'UTC') ?? 'None';
  }
}
